import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class EmailConfigurationAPI {

  static ModelNo = 41;

  static list = (list, success, failure) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    const body = { filter: filter, page: page, perPage: perPage };
    
    fetch(Config.app.link + 'api/sms-config/list', new Header('POST', body))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static get = (id, success, failure) => {
    fetch(Config.app.link + 'api/sms-config/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static save = (lead, success, failure) => {
    fetch(Config.app.link + 'api/sms-config/add-edit', new Header('POST', lead))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/sms-config/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}

export default EmailConfigurationAPI;